module.exports = __webpack_public_path__ + "static/media/video.ac54dca6.png";